import React from 'react';
import { Segment, Divider } from 'semantic-ui-react';
import { SemanticContainer, SemanticSegment } from './styled';

import { withRouter } from 'react-router-dom';
import AdminMenu from '../../../../components/Admin/MenuDetalhes/AdminMenu'
import Back from '../../../../components/Admin/TrilhasVoitto/Editar/Back';
import Formulario from '../../../../components/Admin/TrilhasVoitto/Editar/Formulario';
import { getUSER } from '../../../../services/auth';
const BlogColunistas = props => {
  return (
    <div style={{ width: '100%', paddingLeft: '250px' }}>
      <AdminMenu />
      <SemanticContainer>
        <Back />
        <h2>Editar Trilhas para Alunos</h2>
        <Divider />
        <Segment>
          <Formulario />
        </Segment>
      </SemanticContainer>
      <SemanticContainer>
        <SemanticSegment >
          Grupo Voitto <i class="copyright outline icon"></i>2023
        </SemanticSegment>
      </SemanticContainer>
    </div>
  )
}

export default withRouter(BlogColunistas);